module.exports = __webpack_public_path__ + "vinay-978821e644beda6d73da.jpeg";